// REACT IMPORTS

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import ForgotPasswordForm from "components/auth/ForgotPasswordForm";
import QuestionsFooter from "components/auth/QuestionsFooter";
import Helment from "components/layout/helmet";
import { TestIdScope } from "utils/testid";

/* ------------------------------------- FORGOT PASSWORD PAGE ------------------------------------- */

const ForgotPassword = () => {
  return (
    <>
      <Helment />
      <TestIdScope scope="auth-forgot-password">
        <div
          data-testid="auth-forgot-password-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex flex-col lg:flex-row lg:justify-center relative animate__animated animate__fadeIn"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 h-full w-full flex flex-col items-center justify-between overflow-y-auto">
            <div className="lg:pt-[134px] p-5 w-full flex justify-center">
              <ForgotPasswordForm />
            </div>
            <div className={`pb-5 lg:pt-0 pt-4`}>
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default ForgotPassword;
